import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { AuthState } from "@/redux/slice/auth/types/AuthState";
import fetchUserTypeBuilder from "@/redux/slice/auth/builders/fetchUserType";
import authSignOutBuilder from "@/redux/slice/auth/builders/authSignOut";

const asyncAuthReducers = (builder: ActionReducerMapBuilder<AuthState>) => {
  fetchUserTypeBuilder(builder);
  authSignOutBuilder(builder);
};

export default asyncAuthReducers;
